import React, { useEffect } from "react";
import "./ContactUs.css";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || "info@vh2networks.com";

const MailIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </svg>
);

const PinIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21Z" />
    <circle cx="12" cy="9.5" r="2.5" />
  </svg>
);

const ContactUs = () => {
  useEffect(() => {
    document.title = "Contact Us";
  }, []);

  return (
    <div className="cu-page">
      <div className="cu-logo-bar">
        <Link to="/home">
          <img
            src={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_APP_LOGO}`}
            alt="Logo"
            className="cu-logo"
          />
        </Link>
      </div>

      <main className="cu-main">
        {/* ── Intro ── */}
        <section className="cu-hero">
          <p className="cu-eyebrow">Get in Touch</p>
          <h1 className="cu-title">
            Contact <span className="cu-title-accent">Us</span>
          </h1>
          <p className="cu-lead">
            Questions, business inquiries, or need support? Email is the fastest way to reach us.
          </p>
        </section>

        {/* ── Contact cards ── */}
        <section className="cu-cards">
          <div className="cu-card cu-card--primary">
            <div className="cu-card-head">
              <span className="cu-card-icon"><MailIcon /></span>
              <h2 className="cu-card-title">Email Us</h2>
            </div>
            <p className="cu-card-text">General, partnership, advertising &amp; support inquiries.</p>
            <a href={`mailto:${CONTACT_EMAIL}`} className="cu-card-email">
              {CONTACT_EMAIL}
              <span className="cu-card-arrow" aria-hidden="true">→</span>
            </a>
            <span className="cu-card-watermark"><MailIcon /></span>
          </div>

          <div className="cu-card">
            <div className="cu-card-head">
              <span className="cu-card-icon"><PinIcon /></span>
              <h2 className="cu-card-title">Mailing Address</h2>
            </div>
            <address className="cu-card-address">
              VH2 Networks<br />
              PO Box 1256<br />
              Cumming, GA 30028
            </address>
            <span className="cu-card-watermark"><PinIcon /></span>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ContactUs;
